<template>
  <div>
    <div class="bottom-menu">
      <button class="menu-item" @click="$router.push('/sidebar')">
        <i class="fas fa-bars"></i>
      </button>
      <button class="menu-item mr-5">
        <i class="fas fa-bell"></i>
      </button>
      <a class="menu-item sos" :href="'tel:192'">
        SOS
      </a>
      <button class="menu-item ml-5" @click="instagram">
        <i class="fab fa-instagram"></i>
      </button>
      <button class="menu-item">
        <i class="fas fa-cog"></i>
      </button>

      <!-- Botão Flutuante do WhatsApp -->
      <button class="whatsapp-btn" @click="whatsapp">
        <i class="fab fa-whatsapp"></i>
      </button>
    </div>
  </div>

</template>
<script>
export default {
  name: "BottomMenu",
  methods: {
    confirmarPresenca() {
      this.$router.push("/confirmacao");
    },
    entrarComunidade() {
      window.open(
        "https://chat.whatsapp.com/K2AuKfzGAZK6n3xUl3sTgR",
        "_blank"
      );
    },
    pesquisaSatisfacao() {
      this.$router.push("/pesquisa");
    },
    editarInformacoes() {
      this.$router.push("/registro");
    },
    whatsapp() {
      window.open(
        "https://chat.whatsapp.com/K2AuKfzGAZK6n3xUl3sTgR",
        "_blank"
      );
    },
    instagram() {
      window.open(
        "https://www.instagram.com/institutoimpulsionar/",
        "_blank"
      );
    },
  },
};
</script>
<style scoped>
.bottom-menu {
  display: flex;
  justify-content: space-between;
  /* Aumenta o espaçamento */
  align-items: center;
  background: white;
  padding: 15px 15px;
  /* box-shadow: 0px -2px 10px rgba(0, 0, 0, 0.2); */
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
}

.menu-item {
  background: none;
  border: none;
  font-size: 18px;
  color: #6c757d;
  cursor: pointer;
}

.sos {
  background: red;
  color: white;
  width: 70px;
  /* Aumenta o tamanho */
  height: 70px;
  border-radius: 50%;
  font-size: 18px;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.3);
  position: absolute;
  top: -20px;
  /* Move para cima */
  left: 50%;
  transform: translateX(-50%);
}

.whatsapp-btn {
  position: fixed;
  bottom: 80px;
  right: 20px;
  background: #25d366;
  color: white;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  font-size: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.3);
  border: none;
  cursor: pointer;
}
</style>
